import React from "react";
import { generateCRUDRoutes } from "../../../utils/index";

import { FaAward } from "react-icons/fa6";
import TrainingCertificates from "./index";
// import ViewTrainingOverview from "./view";
// import EditTrainingOverview from "./edit";
import { MODULE_TRAINING } from "variables/constants";

const trainingCertificationRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Certifications",
		basePath: "training-certifications",
		mainComponent: <TrainingCertificates />,
	    layout: "/console",	   
	    icon: <FaAward className="icon-item" />,
	    subTitle:"Training Certifications",
	    // viewComponent: <ViewTrainingOverview />,
	    // createComponent: <EditTrainingOverview />,
	    // editComponent: <EditTrainingOverview />,
		level:5,
		moduleId: 0,
	})
]

export default trainingCertificationRoutes;